import ConfigData from 'config/ConfigData';
import getAppSite from 'utils/getAppSite';

const TweetsFilters = ConfigData?.analyticsTweetFilters;
let graphDataSections = [
  {
    name: 'Spoken parliamentary contributions',
    type: 'ParliamentaryRecord',
    field: 'contentType',
    value: 'ParliamentaryContribution',
  },
  {
    name: 'Written questions',
    type: 'ParliamentaryRecord',
    field: 'contentType',
    value: 'QuestionAndAnswer',
  },
  {
    name: 'EDMs',
    type: 'ParliamentaryRecord',
    field: 'contentType',
    value: 'Edm',
  },
  {
    name: 'Committee contributions',
    type: 'ParliamentaryRecord',
    field: 'contentType',
    value: 'SeneddCommitteeTranscriptContribution',
  },
];

if (getAppSite() === 'usa') {
  graphDataSections = [
    {
      name: 'Congressional records',
      type: 'ParliamentaryRecord',
      field: 'contentType',
      value: 'CREC',
    },
  ];
}

if (import.meta.env.VITE_APP_ENABLE_TWITTER === 'true') {
  graphDataSections = [
    ...graphDataSections,
    {
      name: 'Tweets',
      type: 'Tweet',
      field: 'isRetweet',
      value: 'false',
      additionalFilters: TweetsFilters,
    },
    {
      name: 'Retweets',
      type: 'Tweet',
      field: 'isRetweet',
      value: 'true',
      additionalFilters: TweetsFilters,
    },
  ];
}

export default graphDataSections;
